import _defineProperty from "/var/www/chirpyest_web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createTransport } from '@sentry/core';
import { getNativeFetchImplementation } from './utils.js';
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */

function makeFetchTransport(options) {
  var nativeFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getNativeFetchImplementation();

  function makeRequest(request) {
    var requestOptions = _objectSpread({
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers
    }, options.fetchOptions);

    return nativeFetch(options.url, requestOptions).then(function (response) {
      return {
        statusCode: response.status,
        headers: {
          'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
          'retry-after': response.headers.get('Retry-After')
        }
      };
    });
  }

  return createTransport(options, makeRequest);
}

export { makeFetchTransport };